// extracted by mini-css-extract-plugin
export default {"pageWrapper":"Paymant_pageWrapper__-ej1e","pageContainer":"Paymant_pageContainer__JCwSi"};